import React, { useEffect, useState } from "react";
import "./BlogNewsletter.css";
import { API_URL, BACKEND_URL } from "../util/api";
import { Link, useNavigate } from "react-router-dom";

export default function BlogNewsletter({ type = "article", margin = "2cm"  ,  from="home"  }) {
  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate   = useNavigate();

  const truncate = (str, n = 60) => {
    if (!str) return "";
    return str.length > n ? str.substring(0, n).trimEnd() + "…" : str;
  };



  const fetchBlogs = async (pageNumber = 1) => {
    setLoading(true);
    //check if the type value has change
    
    try {
      const res = await fetch(`${API_URL}/blogs?page=${pageNumber}&type=${type}`);
      const data = await res.json();
      setBlogs(data.data);
      setPage(data.current_page);
      setLastPage(data.last_page);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchBlogs(page);
  }, [page]);

  useEffect(() => {
    setBlogs([]);
    setPage(1);
    fetchBlogs(1);
  }, [type]);


  return (
    <div className="bnxp-container" style={{ marginTop: margin }}>

   {/*  {  blogs.length > 0 && */}

      <header className="bnxp-header">
        <h1 className="bnxp-title">  {type === "article" ? "Insights & Articles" : "Sermons"}</h1>
        {/*  <p className="bnxp-subtitle">Premium knowledge, crafted for modern developers</p> */}
      </header>
{/* } */}


      {loading && <p className="bnxp-loading"><strong>Loading...</strong></p>}

      <div className="bnxp-grid">
        {blogs.map((blog) => (
          <div key={blog.id} className="bnxp-card">
            <div className="bnxp-image-box">
              <img
                src={BACKEND_URL + blog.image}
                alt={blog.title}
                loading="lazy"
                className="bnxp-image"
              />
              <div className="bnxp-overlay"></div>
              <span className="bnxp-tag">{blog.tag}</span>
            </div>

            <div className="bnxp-content">
              <span className="bnxp-date">{blog.date}</span>
              <h2 className="bnxp-card-title">{truncate(blog.title, 60)}</h2>
              {/* <p className="bnxp-description">{blog.body}</p> */}

              <div className="bnxp-footer">
                <div className="bnxp-author-box">
                  <div className="bnxp-avatar"></div>
                  <span>{blog.author}</span>
                </div>
                <button   onClick={() => navigate(`/news/${blog.id}`)} className="bnxp-btn">Explore  </button>
              </div>
            </div>
          </div>
        ))}
      </div>


         {(blogs.length === 0  && loading === false) && <div> <h5 align="center" style={{ color: "black" }}>No posts found.</h5></div>}


      {/* PAGINATION */}

      {from !== "home" ?
        <div className="bnxp-pagination">


          <button
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
            className="bnxp-page-btn"
          >
            Prev
          </button>

          {[...Array(lastPage)].map((_, i) => (
            <button
              key={i}
              onClick={() => setPage(i + 1)}
              className={`bnxp-page-number ${page === i + 1 ? "active" : ""}`}
            >
              {i + 1}
            </button>
          ))}

          <button
            disabled={page === lastPage}
            onClick={() => setPage(page + 1)}
            className="bnxp-page-btn"
          >
            Next
          </button>
        </div>

        :

        <>

          {blogs.length > 0 && 

          <div align="center">
            <br />
            { type === "article" ?  
            <Link to="/news" className="btn btn-sm  btn-primary"> View All </Link> :
             <Link to="/sermon" className="btn btn-sm  btn-primary"> View All </Link> }
           
            
          </div>

            }

        </>

      }


    </div>
  );
}

